import classNames from 'clsx';
import React, {  } from 'react';
import { noop } from 'reactApp/utils/helpers';

import styles from './DisableButton.css';

interface IProps {
    text?: string;
    className?: string;
    onClick?: () => void;
    id?: string;
    href: string;
}

export const DisableButtonComponent = ({ text, className = '', onClick = noop, href }: IProps) => {
    return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a
            className={classNames(styles.disable, className)}
            href={href}
            onClick={onClick}
            target="_blank"
        >
            {text}
        </a>
    );
};
